import { Filter, sharedConfig } from '@witkac/kartamiejska-shared';
import { tryParseInt } from '@witkac/utils/tryParseInt';
import { Route } from 'vue-router';

/**
 * Bazowe filtry na podstawie query
 *
 * @export
 * @param {Route} route
 * @param {number} [count=sharedConfig.onPage]
 * @returns {Filter}
 */
export function baseFilters(route: Route, count: number = sharedConfig.onPage): Filter {
  const filters: Filter = {};

  filters.count = count;

  if (route.query.search) {
    filters.search = route.query.search as string;
  }

  if (route.query.page) {
    const page = (tryParseInt(route.query.page) as number) - 1;
    filters.start = page * count;
  }

  if (route.query.order) {
    filters.order = route.query.order as string;
    filters.desc = route.query.desc === 'true';
  }

  return filters;
}
